import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const List = styled.div`
    display: flex;
    flex-direction: column;
`;

/*
* Вертикальная лента без MUI Lab Timeline: кит в MUI не ходит, а вся разметка ленты — это
* точка, линия между точками и две подписи. Линию рисуем на самом элементе (::before),
* поэтому у последнего её просто нет.
* */
export const Entry = styled.div<{ $isLast: boolean }>`
    position: relative;
    display: flex;
    gap: 12px;
    padding-bottom: ${(props) => (props.$isLast ? "0" : "16px")};

    &::before {
        content: "";
        position: absolute;
        left: 3px;
        top: 14px;
        bottom: 0;
        width: 2px;
        background: ${(props) => (props.$isLast ? "transparent" : colors.divider)};
    }
`;

export const Dot = styled.span`
    flex: 0 0 auto;
    width: 8px;
    height: 8px;
    margin-top: 6px;
    border-radius: 50%;
    background: ${colors.primary};
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const Status = styled.div`
    color: ${colors.textPrimary};
`;

export const ChangedAt = styled.div`
    font-size: 12px;
    color: ${colors.textSecondary};
`;
